import { useQuery } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import { getPrivateInstance } from "../_privateInstance";

export type CasinoOverviewKpiCardsFilters = {
  start_date: string;
  end_date: string;
};

export type CasinoOverviewKpiCardData = {
  value: number;
  previous_value: number;
  percent_change: number | null;
};

export type CasinoOverviewKpiCardsResponse = {
  turnover: CasinoOverviewKpiCardData;
  ggr: CasinoOverviewKpiCardData;
  margin_pct: CasinoOverviewKpiCardData;
  total_rounds: CasinoOverviewKpiCardData;
  avg_bet_amount: CasinoOverviewKpiCardData;
  total_users: CasinoOverviewKpiCardData;
};

export const fetchCasinoOverviewKpiCards = async (
  filters: CasinoOverviewKpiCardsFilters,
): Promise<CasinoOverviewKpiCardsResponse> => {
  const instance = getPrivateInstance();

  const response = await instance.get(API_ROUTES.CASINO_KPI_CARDS, {
    params: filters,
  });

  const data = response?.data?.data;
  if (!data) {
    throw new Error("Invalid response: missing casino KPI data");
  }
  return data;
};

export const useGetCasinoOverviewKpiCards = (
  filters: CasinoOverviewKpiCardsFilters,
) => {
  const { start_date, end_date } = filters;

  return useQuery<CasinoOverviewKpiCardsResponse, Error>({
    queryKey: ["CASINO_KPI_CARDS", start_date, end_date],
    queryFn: () => fetchCasinoOverviewKpiCards(filters),
    enabled: Boolean(start_date && end_date),
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
